<template>
  <div class="splash">
    <div class="color-line"></div>
    <div class="splash-title">
      <h1>IdeXlab</h1>
      <p>Innovate Faster, Innovate Better!  </p>
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .spinner>div {
    background-color: #3498db;
  }

  .splash {
    display: block;
  }

</style>
<script>
export default {
  name: 'Splash',
}
</script>



// WEBPACK FOOTER //
// src/components/Splash.vue